import { render } from "./CatProjects.vue?vue&type=template&id=08cefe50"
import script from "./CatProjects.vue?vue&type=script&lang=js"
export * from "./CatProjects.vue?vue&type=script&lang=js"

import exportComponent from "/Users/alexeysorokin/Desktop/hexp2/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__